module.exports = __webpack_public_path__ + "static/img/rank_87.2300fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_87.png
// module id = pHMx
// module chunks = 1